import { putAction } from "@/api/manage";
export default {
  data: function data() {
    return {
      validatorRules: {
        oldpassword: {
          rules: [{
            required: true,
            message: "请输入旧密码!"
          }]
        },
        password: {
          rules: [{
            required: true,
            message: "请输入新密码!"
          }, {
            validator: this.validateToNextPassword
          }]
        },
        confirmpassword: {
          rules: [{
            required: true,
            message: "请确认新密码!"
          }, {
            validator: this.compareToFirstPassword
          }]
        }
      },
      confirmDirty: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      form: this.$form.createForm(this),
      url: "sys/user/updatePassword",
      username: ""
    };
  },
  created: function created() {
    this.username = this.$store.getters.username;
  },
  methods: {
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit("close");
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
    },
    handleOk: function handleOk() {
      var _this = this;
      var that = this;
      // 触发表单验证
      this.form.validateFields(function (err, values) {
        if (!err) {
          var params = Object.assign({
            username: _this.username
          }, values);
          console.log("修改密码提交数据", params);
          putAction(_this.url, params).then(function (res) {
            if (res.success) {
              that.form.resetFields();
              that.$message.success(res.message);
            } else {
              that.$message.warning(res.message);
            }
          }).finally(function () {});
        }
      });
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      var form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], {
          force: true
        });
      }
      callback();
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次输入的密码不一样！");
      } else {
        callback();
      }
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    }
  }
};